import type { EditorView } from "@tiptap/pm/view";

export function minMax(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/* /Users/toi/Desktop/project/ourpr/node_modules/@tiptap/core/src/helpers/posToDOMRect.ts */
export function posToDOMRect(
  view: EditorView,
  from: number,
  to: number,
): DOMRect {
  const minPos = 0;

  const maxPos = view.state.doc.content.size;
  const resolvedFrom = minMax(from, minPos, maxPos);
  const resolvedEnd = minMax(to, minPos, maxPos);

  /// 多分何個め？

  // 何こめ? から positionを取得

  /* 
  /Users/toi/Desktop/project/ourpr/node_modules/prosemirror-view/dist/index.d.ts
  Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.

  */
  const start = view.coordsAtPos(resolvedFrom);

  const end = view.coordsAtPos(resolvedEnd, -1);
  const top = Math.min(start.top, end.top);
  const bottom = Math.max(start.bottom, end.bottom);
  //const left = Math.min(start.left, end.left);
  //const right = Math.max(start.right, end.right);
  //const width = right - left;
  const height = bottom - top;
  //const x = left;
  const y = top;
  const data = {
    top,
    bottom,
    left: 0,
    right: 0,
    width: 0,
    height,
    x: 0,
    y,
  };
  return {
    ...data,
    toJSON: () => data,
  };
}